import { render, staticRenderFns } from "./PolicyCardPension.vue?vue&type=template&id=5c76b605&"
import script from "./PolicyCardPension.vue?vue&type=script&lang=ts&"
export * from "./PolicyCardPension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports